import { CognitoUserPool } from 'amazon-cognito-identity-js'
import POOL_DATA from './poolData'

const cognitoUserPool = new CognitoUserPool(POOL_DATA)

export default cognitoUserPool



// WEBPACK FOOTER //
// ./src/cognito-objects/cognitoUserPool.js